import useThemeMode      from '@widesk-ui/hooks/useThemeMode';
import type { CSSProperties } from 'react';

type LogoProps = {
	short?: boolean;
	forceMode?: 'light' | 'dark'; // Ignore le thème général du site (ex: sur un fond toujours sombre comme le header)
	style?: CSSProperties;
	className?: string;
};

const Logo = ({ short, forceMode, style, className }: LogoProps) => {
	const { mode: themeMode } = useThemeMode();
	const mode = forceMode || themeMode;

	if (short) {
		return <img src={`/favicon.svg`} alt="Tokamap" style={style} className={className} />;
	}

	return <img src={`/${mode === 'dark' ? 'logo-white' : 'logo'}.svg`} alt="Tokamap" style={style} className={className} />;
};

export default Logo;
